<template>
  <div class="box-filter">
    <el-form :model="ruleForm" ref="ruleForm" @submit.prevent v-on:submit.prevent>
      <el-row :gutter="20">
        <el-col :sm="19" :md="19">
          <div class="textfilter">
            <el-input size="large" v-model="ruleForm.searchInput" class="input-with-select">
              <el-button slot="append" icon="el-icon-search" native-type="submit" @click.prevent="searchTable" />
            </el-input>
            <el-tooltip v-if="ruleForm.searchInput" effect="dark" content="Limpar Filtro" placement="top">
              <el-button @click="clearSearch" type="text" class="clear-filter">
                <XIcon size="1.5x" />
              </el-button>
            </el-tooltip>
          </div>
        </el-col>
        <el-col :sm="5" :md="5">
          <el-button type="default" size="large" @click="viewFilter = !viewFilter">
            Filtros por:<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
        </el-col>
      </el-row>
      <div v-if="viewFilter" class="viewFilter">
        <el-row :gutter="20">
         <el-col :span="8">
           <el-form-item prop="type_person" label="Tipo">
             <el-select v-model="ruleForm.type_person" clearable>
               <el-option label="Empresa" value="business" />
               <el-option label="Individual" value="individual" />
             </el-select>
           </el-form-item>
         </el-col>
         <el-col :span="8">
           <el-form-item prop="cpf" label="CPF">
             <el-input masked="true" :autofocus="true" size="large" v-model="ruleForm.cpf" v-mask="['###.###.###-##']" required />
           </el-form-item>
         </el-col>
         <el-col :span="8">
           <el-form-item prop="business_cnpj" label="CNPJ">
             <el-input masked="true" :autofocus="true" size="large" v-model="ruleForm.business_cnpj" v-mask="['##.###.###/####-##']" required />
           </el-form-item>
         </el-col>
        </el-row>
        <el-row type="flex" class="row-bg" justify="end">
          <el-col :xs="24" :span="15">
            <el-button  native-type="submit" @click.prevent='searchTable' type="primary" size="large" style="float: right">
              Filtrar
            </el-button>
            <el-button v-if="statusClearFilter" @click='clearSearch' type="default" size="large" style="float: right; margin-right: 20px">
              Limpar Filtros
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
import {XIcon} from "vue-feather-icons";

export default {
  name: "FilterBox",
  components: {
    XIcon,
  },
  data () {
    return {
      loadingPage: true,
      ruleForm: {
        searchInput: '',
        type_person: null,
        cpf: null,
        business_cnpj: null,
      },
      viewFilter: false,
    }
  },
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    type: {
      type: Number,
      default: 0
    }
  },
  computed: {
    statusClearFilter: function () {
      if (this.ruleForm.searchInput || this.ruleForm.type_person || this.ruleForm.cpf || this.ruleForm.business_cnpj) {
        return true
      }
      return false
    }
  },
  methods: {
    clearSearch () {
      this.viewFilter = false
      this.ruleForm = {
        searchInput: '',
        name_store: null,
        type_person: null,
        cpf: null,
        business_cnpj: null,
        status: null,
      }
      this.$emit('filter', `?page=${this.currentPage}`)
    },
    searchTable () {
      let query = `?page=${this.currentPage}`

      if (this.ruleForm.searchInput) {
        query = `${query}&name_store=${this.ruleForm.searchInput}`
      }
      if (this.ruleForm.type_person) {
        query = `${query}&type_person=${this.ruleForm.type_person}`
      }
      if (this.ruleForm.cpf) {
        query = `${query}&cpf=${this.ruleForm.cpf.replace(/[^\d]+/g, '')}`
      }
      if (this.ruleForm.business_cnpj) {
        query = `${query}&business_cnpj=${this.ruleForm.business_cnpj.replace(/[^\d]+/g, '')}`
      }
      if (this.ruleForm.status) {
        query = `${query}&status=${this.ruleForm.status}`
      }
      this.$emit('filter', query)
    },
  }
}
</script>

<style scoped>

</style>
